import * as React from 'react';

function SvgHearth(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17.374 14.892" {...props}>
      <path
        data-name="Path 4036"
        d="M16.143 1.202a4.663 4.663 0 00-3.4-1.2 3.866 3.866 0 00-1.226.208 4.957 4.957 0 00-1.163.562q-.538.354-.926.664a8.96 8.96 0 00-.737.659 8.972 8.972 0 00-.737-.659q-.388-.31-.926-.664A4.964 4.964 0 005.865.21 3.867 3.867 0 004.639.002a4.663 4.663 0 00-3.4 1.2A4.447 4.447 0 000 4.537a4.248 4.248 0 00.228 1.338 5.869 5.869 0 00.519 1.178 8.578 8.578 0 00.659.945q.368.461.538.635a3.2 3.2 0 00.267.252l6.05 5.837a.609.609 0 00.853 0l6.04-5.817a6.339 6.339 0 002.22-4.363 4.447 4.447 0 00-1.231-3.34z"
        fill="#c83526"
      />
    </svg>
  );
}

export default SvgHearth;
